export enum CONSENT_DOMAIN {
  PROD = 'consent.talpanetwork.com',
  ACC = `acc.consent.talpanetwork.com`
}
